export enum FilterInputType {
    Calendar = "calendar",
    Checkbox = "checkbox",
    Text = "text", // Default
    Number = "number",
    Dropdown = "dropdown",
    Multiselect = "multiselect"
}
